/**
 * "CLI configuration files" — CLI section (ADR-0074).
 * Reconciled from packages/cli/src config + output modules.
 */
import type { DocPageContent } from '../types';

export const CLI_CONFIG_PAGE: DocPageContent = {
  slug: 'cli/config',
  titleKey: 'docs.cli.config.title',
  descriptionKey: 'docs.cli.config.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.cli.config.lead' },
    {
      kind: 'definitions',
      variant: 'code',
      items: [
        {
          termKey: 'docs.cli.config.file.ignore.term',
          descKey: 'docs.cli.config.file.ignore.desc',
        },
        { termKey: 'docs.cli.config.file.yaml.term', descKey: 'docs.cli.config.file.yaml.desc' },
        {
          termKey: 'docs.cli.config.file.catalog.term',
          descKey: 'docs.cli.config.file.catalog.desc',
        },
        {
          termKey: 'docs.cli.config.file.consent.term',
          descKey: 'docs.cli.config.file.consent.desc',
        },
        {
          termKey: 'docs.cli.config.file.credentials.term',
          descKey: 'docs.cli.config.file.credentials.desc',
        },
        {
          termKey: 'docs.cli.config.file.overlay.term',
          descKey: 'docs.cli.config.file.overlay.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.cli.config.commit.title',
      textKey: 'docs.cli.config.commit.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.cli.config.next.reference.title',
          textKey: 'docs.cli.config.next.reference.text',
          to: { docSlug: 'cli/reference' },
        },
        {
          titleKey: 'docs.cli.config.next.frameworks.title',
          textKey: 'docs.cli.config.next.frameworks.text',
          to: { docSlug: 'cli/frameworks' },
        },
      ],
    },
  ],
};
